import React, { useState, useEffect } from "react";
import { Smartphone, X } from "lucide-react";
import { Button } from "./ui/button";
import { cn } from "../lib/utils";

const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    setIsMobile(mq.matches);

    const isInstalled =
      window.matchMedia("(display-mode: standalone)").matches ||
      (window.navigator as any).standalone ||
      document.referrer.includes("android-app://");

    if (isInstalled) return;

    const wasRejected = localStorage.getItem("pwaPromptRejected") === "true";
    const shownRecently =
      localStorage.getItem("lastPromptShown") &&
      Date.now() - parseInt(localStorage.getItem("lastPromptShown")!) <
        7 * 24 * 60 * 60 * 1000;

    if (wasRejected || shownRecently) return;

    const handleBeforeInstall = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsVisible(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstall);
    const timer = setTimeout(() => {
      if (!isInstalled && mq.matches) setIsVisible(true);
    }, 30000);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstall);
      clearTimeout(timer);
    };
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      setDeferredPrompt(null);
    }
    setIsVisible(false);
  };

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem("pwaPromptRejected", "true");
  };

  if (!isVisible || !isMobile) return null;

  return (
    <div className="fixed bottom-[64px] left-0 right-0 z-40 px-3 pb-2 animate-fade-in">
      <div className="bg-card rounded-2xl shadow-lg border border-border/60 p-3 flex items-center gap-3">
        <div className="size-9 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
          <Smartphone className="size-5 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-foreground leading-tight">Instalá la app</p>
          <p className="text-xs text-muted-foreground leading-tight mt-0.5">Accedé más rápido, sin conexión</p>
        </div>
        <div className="flex items-center gap-1.5 shrink-0">
          <Button variant="outline" size="sm" onClick={handleClose} className="h-8 px-3 text-xs rounded-lg">
            No
          </Button>
          <Button size="sm" onClick={handleInstall} className="h-8 px-3 text-xs rounded-lg">
            Instalar
          </Button>
        </div>
        <button
          onClick={handleClose}
          className="p-1 rounded-md text-muted-foreground hover:text-foreground hover:bg-muted transition-colors shrink-0"
          aria-label="Cerrar"
        >
          <X className="size-3.5" />
        </button>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;
